export default __webpack_public_path__ + "static/4-33e36a48ccac65630990dc027ce67e8f.jpg";